import { render, staticRenderFns } from "./BkAvatar.vue?vue&type=template&id=b7bd9a5e"
import script from "./BkAvatar.vue?vue&type=script&lang=js"
export * from "./BkAvatar.vue?vue&type=script&lang=js"
import style0 from "./BkAvatar.vue?vue&type=style&index=0&id=b7bd9a5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports